import React from 'react';

const SkeletonRecordCard = () => {
  return (
    <div className="bg-white border border-gray-100 rounded-3xl overflow-hidden shadow-sm animate-pulse mb-6">
      <div className="p-5 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 bg-gray-200 rounded-2xl"></div>
          <div className="space-y-2">
            <div className="h-4 w-24 bg-gray-200 rounded"></div>
            <div className="h-3 w-16 bg-gray-100 rounded"></div>
          </div>
        </div>
        <div className="h-6 w-20 bg-gray-100 rounded-full"></div>
      </div>
      
      <div className="aspect-[4/3] bg-gray-200 w-full"></div>
      
      <div className="p-5 space-y-4">
        <div className="space-y-2">
          <div className="h-4 w-3/4 bg-gray-200 rounded"></div>
          <div className="h-4 w-1/2 bg-gray-200 rounded"></div>
        </div>
        
        <div className="pt-4 border-t border-gray-50 flex items-center gap-3">
          <div className="w-8 h-8 bg-gray-100 rounded-full"></div>
          <div className="h-3 w-20 bg-gray-100 rounded"></div>
        </div>
      </div>
    </div>
  );
};

export default SkeletonRecordCard;
